module.exports = __webpack_public_path__ + "static/media/a4_01.911de2d0.jpg";